<mat-card class="dashboard">
    <mat-card-header>
      <mat-card-title>Welcome to Admin Panel</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="nav-container">
        <nav mat-tab-nav-bar>
          <!-- <a mat-tab-link *ngFor="let link of navLinks" [routerLink]="link">{{ link }}</a> -->
        </nav>
        <div class="contact-links">
          <a >Contacts & Agent Booking</a>
          <a >Deal Sheets</a>
          <a >Supplier Deal Sheets</a>
        </div>
        <a class="performance-link" >Track Your Performance</a>
      </div>
      <div class="col-md-12 row">
        
      <div class="category col-md-4" *ngFor="let category of categories">
        <h2>{{ category.name }}</h2>
        <!-- matBadge="{{ item.count }}" matBadgePosition="after" -->
        <mat-list>
          <mat-list-item *ngFor="let item of category.items" [ngClass]="item.status">
            {{ item.name }} 
            <!-- <span class="circle"  >{{ item.count }}</span> -->
            <!-- <p-progressBar [value]="item.count">
              <ng-template pTemplate="content" let-value> 
              <span>{{value}}</span>    
              </ng-template>
          </p-progressBar> -->
            <button  mat-ico-button style=" width: 30px;
            height: 30px;
            background-color: #3F50B5; /* Default background color */
            border: none;
            border-radius: 50%; /* Makes the button circular */
            cursor: pointer;
            transition: background-color 0.3s ease; /* Smooth color transition */
            /* display: flex; */
            justify-content: center;
            font-size: small;
            align-items: center; color: white;" color="primary" class="circle-button"> <span class="plus-icon pb-1">{{ item.count }}</span></button>

          </mat-list-item>
        </mat-list>
      </div>
    </div>
    </mat-card-content>
  </mat-card>